<script setup lang="ts">
import { t } from '@/locales/i18n'
import GwBtn from '@/components/lib/GwBtn/GwBtn.vue'

const emit = defineEmits<{
  'remove:filter': []
}>()
</script>

<template>
  <GwBtn
    variant="btn_text_grey_error"
    data-tst="remove_filter"
    icon="mdi-trash-can"
    @click="emit('remove:filter')"
  >
    {{ t('hhv3.remove_filter') }}
  </GwBtn>
</template>
